<template>
    <!-- 工作人员监考详情 列表页 -->
    <div ref="boardRef">
        <el-form :inline="true" :model="form" ref="form">
            <el-form-item>
                <el-input v-model.trim="form.reviewerName" clearable :placeholder="searchTextConfig.reviewerName"></el-input>
            </el-form-item>
            <el-form-item>
                <el-select v-model="form.faceCheckStatus" clearable :placeholder="searchTextConfig.faceCheckStatus">
                    <el-option v-for="item in faceCheckStatusOptions" :key="item.dict_value" :label="item.dict_label"
                               :value="item.dict_value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
                <el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
            </el-form-item>

            <el-form-item>
                <span>
                    <el-button v-hasPermi="['invigilate:detail:download']" type="primary" :loading="reviewerLoading" @click="download" style="margin-left: 10px">
                        {{ detailTextConfig.button.download }}
                    </el-button>
                </span>
            </el-form-item>

            <el-form-item>
                <span>
                  <el-button type="primary" @click="downloadImg" :loading="reviewerImgLoading" style="margin-left: 10px">
                    {{ detailTextConfig.button.downloadImg }}
                  </el-button>
                </span>
            </el-form-item>

        </el-form>
        <el-table :data="tableData" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                  ref="multipleTable" stripe size="medium" style="width: 100%">
            <el-table-column prop="reviewerName" :label="tableTextConfig.reviewerName" min-width="100px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createdByUsername" :label="tableTextConfig.reviewerUserName" min-width="100px"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="loginIp" :label="tableTextConfig.loginIp" min-width="170px" align="center" show-overflow-tooltip>
                <template slot-scope="scope" v-if="scope.row.loginIp">
                    <p v-for="(item, index) in scope.row.loginIp.split(',')" :key="index" class="multiRow">
                        {{ item }}
                    </p>
                </template>
            </el-table-column>
            <el-table-column prop="faceCheckStatus" :label="tableTextConfig.faceCheckStatus" min-width="200px" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="validateDatetime" :label="tableTextConfig.validateDatetime" min-width="160px" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" :label="tableTextConfig.operate" width="160px" align="center">
                <template slot-scope="scope">
                    <el-button v-hasPermi="['invigilate:detail:list']" plain type="primary" size="mini" @click="detail(scope.row)">
                        {{ tableButtonTextConfig.detail.name }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize" :total.sync="total"></pagination>
        <detail-dialog :row.sync="row" :show.sync="detailDialogVisible" @close="close"></detail-dialog>
    </div>
</template>

<script>

import detailDialog from './components/reviewerDetail.vue'
import pagination from '@/components/pagination/pagination.vue'
import {getDict} from '@/api/dict'
import {getConfig} from '@/api/aiReview'
import {getDetailList, getReviewerDetail} from '@/api/invigilate'
import '@/utils/ai-review.js'
import {downloadBolbFile, parseTime} from "@/utils/common";

window.aiReviewConfig = {
    apiService: {},
    client: {},
}

export default {
    name: 'invigilateDetail',
    components: {
        pagination,
        detailDialog,
    },
    data() {
        return {
            // height: 250,
            loading: true,
            info: {},
            form: {
                examId: '',
                reviewerName: '',
                faceCheckStatus: '',
                pageNumber: 1,
                pageSize: 20,
                authenticationType: 'reviewer',//examinee是考生，reviewer是工作人员
            },
            total: 0,
            questionTypeList: [],
            tableData: [],
            detailDialogVisible: false,
            activeName: '0',
            row: null,
            faceCheckStatusOptions: [
                {dict_value: 'UNCHECKED', dict_label: '未验证'},
                {dict_value: 'PASS', dict_label: '通过'},
                {dict_value: 'NOT_PASS', dict_label: '未通过'},
            ],
            reviewerImgLoading: false,
            reviewerLoading: false,
        }
    },
    computed: {
        detailTextConfig() {
            return this.$store.state.global.textConfig.backend.invigilateDetail
        },
        searchTextConfig() {
            return this.detailTextConfig.search
        },
        tableTextConfig() {
            return this.detailTextConfig.table
        },
        tableButtonTextConfig() {
            return this.tableTextConfig.button
        },
    },
    watch: {
        tableData() {
            if (this.tableData.length == 0) {
                this.height = 120
            } else {
                this.updateHeight()
            }
        },
    },
    inject: ['reload'],
    beforeRouteEnter(to, from, next) {
        if (from.name === 'invigilate') {
            next((vm) => {
                vm.reload()
            })
        } else if (from.name === 'lookPaper') {
            to.meta.isBack = true
            next()
        } else {
            to.meta.isBack = false
            next()
        }
    },
    beforeCreate() {
        getConfig().then((res) => {
            window.aiReviewConfig = res.data
        })
    },
    created() {
        this.initDictData()
        this.info = JSON.parse(localStorage.getItem('setInvigilate'))
        this.search(1)
    },
    mounted() {
        const that = this
        setTimeout(() => {
            that.updateHeight()
        }, 200)
        window.onresize = () => {
            that.updateHeight()
        }
    },
    activated() {
        if (!this.$route.meta.isBack) {
            this.reset()
        } else {
            this.$route.meta.isBack = false
            // this.getBorrowList() /*列表重新加载*/
        }
        this.$route.meta.keepAlive = true
    },
    methods: {
        initDictData() {
            getDict('question_type').then((res) => {
                this.questionTypeList = res.data
            })
        },
        search(val) {
            this.loading = true
            if (val) {
                this.form.pageNumber = val
            }
            this.form.examId = this.info.exam.id
            getDetailList(this.form).then((res) => {
                if (res.status === 200) {
                    this.tableData = res.data.list
                    this.tableData.forEach(item => {
                        if (item.manualCheck === true && item.faceCheckStatus === '验证通过') {
                            item.faceCheckStatus = '验证通过 (人工校验)'
                        }
                    })
                    this.total = res.data.total
                }
                this.loading = false
                this.$refs.multipleTable.bodyWrapper.scrollTop = 0
            }).catch((err) => {
                this.loading = false
            })
        },
        detail(row) {
            this.row = row
            if (row) {
                getReviewerDetail(row.id).then(res => {
                    if (res.status === 200 && res.data) {
                        this.row = res.data
                    } else {
                        this.row = row
                    }
                })
            }
            this.detailDialogVisible = true
        },
        reset() {
            this.form = this.$options.data().form
            this.form.reviewerName = ''
            this.form.faceCheckStatus = null
            this.form.pageSize = 20
            this.search(1)
        },
        download() {
            let url = `${this.config_env.BASE_URL}/api/exam/invigilate/record/detail/download`
            let downloadName = `${this.info.exam.examPlan.name}-工作人员-${parseTime(Date.now())}.xlsx`
            this.reviewerLoading = true
            downloadBolbFile(url, 'get', downloadName, this.form, (loaded, total, percent, status) => {
                if (loaded) {
                    this.reviewerLoading = true
                }
                if (percent === 100) {
                    this.reviewerLoading = false
                }
                if (status === "error") {
                    this.reviewerLoading = false
                }
            })
        },
        downloadImg() {
            let url = `${this.config_env.BASE_URL}/api/exam/invigilate/record/detail/downloadImg`
            let downloadName = `${this.info.exam.examPlan.name}-工作人员现场拍摄照片-${parseTime(Date.now())}.zip`
            this.reviewerImgLoading = true
            downloadBolbFile(url, 'get', downloadName, this.form, (loaded, total, percent, status) => {
                if (loaded) {
                    this.reviewerImgLoading = true
                }
                if (percent === 100) {
                    this.reviewerImgLoading = false
                }
                if (status === "error") {
                    this.reviewerImgLoading = false
                }
            })
        },
        // download() {
        //     let a = document.createElement('a')
        //     let examId = this.info.exam.id
        //     let filename = this.info.exam.examPlan.name
        //     let authenticationType = 'reviewer'
        //
        //     let url = `${this.config_env.BASE_URL}/api/exam/invigilate/record/detail/${examId}/${authenticationType}/download`
        //     a.href = url
        //     a.download = filename
        //     a.click()
        //     window.URL.revokeObjectURL(url)
        // },
        // downloadImg() {
        //     let examId = this.info.exam.id
        //     let filename = this.info.exam.examPlan.name
        //     let authenticationType = 'reviewer'
        //
        //     let url = `${this.config_env.BASE_URL}/api/exam/invigilate/record/detail/${examId}/${authenticationType}/downloadImg`
        //     fetch(url)
        //             .then(response => {
        //                 if (!response.ok) {
        //                     throw new Error('下载失败')
        //                 }
        //                 const contentDisposition = response.headers.get('content-disposition')
        //                 let downloadFilename = filename
        //                 if (contentDisposition) {
        //                     const filenameMatch = contentDisposition.match(/fileName=(.+)/)
        //                     if (filenameMatch && filenameMatch[1]) {
        //                         downloadFilename = decodeURIComponent(filenameMatch[1])
        //                     }
        //                 }
        //                 return response.blob().then(blob => ({blob, downloadFilename}))
        //             })
        //             .then(({blob, downloadFilename}) => {
        //                 const url = window.URL.createObjectURL(blob)
        //                 const a = document.createElement('a')
        //                 a.href = url
        //                 a.download = downloadFilename
        //                 document.body.appendChild(a)
        //                 a.click()
        //                 window.URL.revokeObjectURL(url)
        //                 document.body.removeChild(a)
        //             })
        //             .catch(err => {
        //                 this.$message.error('下载失败')
        //             })
        // },
        close(data, refresh) {
            this.detailDialogVisible = data
            this.row = null

            if (refresh) {
                this.search()
            }
        },
        updateHeight() {
            if (this.$refs.boardRef) {
                const boardEl = this.$refs.boardRef
                const formEl = boardEl.querySelector('.el-form')
                if (formEl) {
                    this.height = boardEl.clientHeight - formEl.clientHeight - 184
                    this.height = this.height < 460 ? 460 : this.height
                }
            }
        },
        submitTypeFormatter(row) {
            if (row.submitType === 'auto') {
                return '系统自动提交'
            } else if (row.submitType === 'manual') {
                return '主动交卷'
            }
            return ''
        },
    },
}
</script>

<style scoped>
.info {
    color: #555;
    font-size: 15px;
    margin-bottom: 12px;
}

.info span {
    color: #c0c4cc;
    margin-left: 12px;
}

.info span:first-child {
    margin-left: 0;
}

.info i {
    color: #555;
}

.multiRow {
    font-size: 12px;
    /*color: #bbb;*/
    line-height: 12px;
}

.lockedClass {
    background-color: #ff9502;
    /*background-color: #FF455B;*/
    display: inline-block;
    padding: 0 2px;
    text-align: center;
    vertical-align: middle;
    font-style: normal;
    color: #fff;
    overflow: hidden;
    line-height: 16px;
    height: 16px;
    font-size: 10px;
    border-radius: 4px;
    font-weight: 200;
}
</style>
